export default {
  loading: "Caricamento punti...",
  errorLoad: "Impossibile caricare i punti",
  title: "I miei punti",
  description: "Punti guadagnati dagli scontrini dei ristoranti caricati",
  currentBalance: "Saldo attuale",
  pointsLabel: "punti",
  recentTitle: "Movimenti recenti",
  emptyTitle: "Nessun movimento punti ancora",
  emptyDescription:
    "Carica uno scontrino di ristorante per guadagnare i primi punti",
} as const;
